"use strict";

exports.__esModule = true;
exports.formatDataSeries = exports.downloadDataFromSeries = void 0;
var _Utils = require("../../../Utils");
var _timeFormatters = require("../../../Utils/timeFormatters");
var TIMESTAMP_HEADER = "Timestamp";
var VALUE_HEADER = "Value";
var formatDataSeries = exports.formatDataSeries = function formatDataSeries(data, dataItemTypeHeaderName) {
  return {
    headers: [TIMESTAMP_HEADER, dataItemTypeHeaderName, VALUE_HEADER],
    rows: Array.isArray(data) ? data.reduce(function (rows, d, index) {
      if (index !== 0) {
        rows.push(["", "", ""]);
      }
      (Array.isArray(d.values) ? d.values : []).forEach(function (v) {
        return rows.push([v.timestamp, d.name, v.value]);
      });
      return rows;
    }, []) : []
  };
};
var downloadDataFromSeries = exports.downloadDataFromSeries = function downloadDataFromSeries(name, data, dataItemTypeHeaderName) {
  (0, _Utils.downloadCSVData)(formatDataSeries(data, dataItemTypeHeaderName), name);
};